//Design system components
import { toast } from '@Shelly/shelly-design-system';
//Services
import { localReq, postReq } from '../services/http';
import { format } from 'svelte-i18n';
//Stores
import { get } from 'svelte/store';
import { app } from 'src/stores/session/native-bridge';
//Helpers
import { real_id } from './interface_helpers';
//SPA stores
import { location } from 'svelte-spa-router';
import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';

export const changeFirmware = async (device, color_mode, localIp) => {
	//This function is used inside ModeRGBW2 and ControlMOde for changing RGBW2 mode
	const $format = get(format);

	let res;
	if (localIp) {
		res = await localReq(device, `${localIp}/settings/`, 'post', {
			mode: color_mode,
		});
	} else {
		res = await postReq(`/device/change_firmware`, {
			mode: color_mode,
			channel: device.channel,
			id: real_id(device.id),
		});
	}
	if (get(app)) {
		//Looking for app because on desktop we have secondary attempt of closing drawer
		setSidePanelState({ open: false }); //Closing this drawer because need to remove secondary controls tab
	} else {
		const type = get(location).split('/')[2];

		setSidePanelState({
			type: type,
			id: type === 'room' ? get(location).split('/')[3] : '-1',
		}); //this prevent image error while user is coming from groups. Type will is group, room, consumption etc.
	}
	if (res.isok) {
		toast.open({ type: 'success', title: $format('fw_update_scc_toast') });
	} else {
		toast.open({ type: 'danger', title: $format('error_global') });
	}
	return res;
};
